import { useLazyGetGeneralFeedbackQuery } from '../slices/fun_stuff/quizAdminSlice';
import { useDispatch } from 'react-redux';
import { setGeneralFeedback } from '../slices/fun_stuff/quizAuthSlice';

export const useLoadGeneralFeedback = () => {
  const dispatch = useDispatch();
  const [getFeedback, { isLoading, error }] = useLazyGetGeneralFeedbackQuery();

  const loadGeneralFeedback = async () => {
    const data = await getFeedback().unwrap();
    dispatch(setGeneralFeedback(data));
    return;
  };

  return { loadGeneralFeedback, isLoading, error };
};
